import React, { useImperativeHandle, forwardRef } from "react";
import { useDropzoneLogic, MyDropzoneRef, MyDropzoneProps } from "../../lib/helpers/Dropzone";

export const MyDropzone = forwardRef<MyDropzoneRef, MyDropzoneProps>(({ onUploadStart, onUploadComplete }, ref) => {
  const {
    uploadedFiles,
    successMessage,
    errorMessage,
    isUploading,
    isDragActive,
    fileInputRef,
    dropZoneRef,
    handleDragEnter,
    handleDragLeave,
    handleDragOver,
    handleDrop,
    handleFileInputChange,
    handleDropzoneClick,
    handleRemoveFile,
    handleProcess,
  } = useDropzoneLogic(onUploadStart, onUploadComplete);

  useImperativeHandle(ref, () => ({ handleProcess }));

  return (
    <section className="container" style={{ width: "100%" }}>
      <input ref={fileInputRef} type="file" accept=".xlsx,.xls" multiple onChange={handleFileInputChange} style={{ display: "none" }} disabled={isUploading} />

      {successMessage && (
        <div style={{ backgroundColor: "#4caf50", color: "white", padding: "12px", borderRadius: "4px", marginBottom: "15px", textAlign: "center" }}>{successMessage}</div>
      )}
      {errorMessage && (
        <div style={{ backgroundColor: "#f44336", color: "white", padding: "12px", borderRadius: "4px", marginBottom: "15px", textAlign: "center" }}>{errorMessage}</div>
      )}

      <div
        ref={dropZoneRef}
        onClick={handleDropzoneClick}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        style={{
          border: `2px dashed ${isDragActive ? "#2196f3" : "#cccccc"}`,
          borderRadius: "4px",
          padding: "20px",
          textAlign: "center",
          cursor: isUploading ? "default" : "pointer",
          backgroundColor: isDragActive ? "#e3f2fd" : "#fafafa",
          minHeight: "150px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "20px",
          transition: "all 0.2s ease",
          opacity: isUploading ? 0.6 : 1,
          pointerEvents: isUploading ? "none" : "auto",
        }}
      >
        {isUploading ? (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div
              style={{ width: "24px", height: "24px", border: "3px solid #f3f3f3", borderTop: "3px solid #3498db", borderRadius: "50%", animation: "spin 1s linear infinite" }}
            />
            <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
            <span>Uploading files...</span>
          </div>
        ) : (
          <p>{isDragActive ? "Drop the Excel file here..." : "Drag 'n' drop Excel files here, or click to select"}</p>
        )}
      </div>

      <aside>
        <h4 style={{ marginBottom: "10px", color: "#555" }}>Files:</h4>
        <ul style={{ listStyle: "none", padding: 0, maxHeight: "200px", overflow: "auto", border: "1px solid #eee", borderRadius: "4px" }}>
          {uploadedFiles.length > 0 ? (
            uploadedFiles.map((file, index) => (
              <li
                key={index}
                style={{ padding: "10px", borderBottom: "1px solid #eee", display: "flex", justifyContent: "space-between", alignItems: "center", opacity: isUploading ? 0.6 : 1 }}
              >
                <span>
                  {file.name} - {file.size} bytes
                </span>
                <button
                  onClick={() => handleRemoveFile(index)}
                  disabled={isUploading}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#f44336",
                    cursor: isUploading ? "not-allowed" : "pointer",
                    fontSize: "18px",
                    fontWeight: "bold",
                    padding: "0 8px",
                    opacity: isUploading ? 0.5 : 1,
                  }}
                  title="Remove file"
                >
                  ×
                </button>
              </li>
            ))
          ) : (
            <li style={{ color: "#999", padding: "10px" }}>No files selected</li>
          )}
        </ul>
      </aside>
    </section>
  );
});
